var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_441_1136",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 5,
    width: 44,
    height: 46
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.11047 5.6H49.8734V50.4H6.11047V5.6Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_441_1136)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.4565 5.60035C13.8869 5.60035 6.11047 13.3765 6.11047 22.9461C6.11047 32.5155 13.8869 40.2917 23.4565 40.2917C27.2428 40.2917 30.7423 39.0721 33.596 37.0074L47.02 50.3995L49.8896 47.5299L36.625 34.2334C39.2319 31.1963 40.8021 27.2547 40.8021 22.9461C40.8021 13.3765 33.0259 5.60035 23.4565 5.60035ZM23.4565 7.64067C31.9219 7.64067 38.7612 14.4805 38.7612 22.9461C38.7612 31.4115 31.9219 38.2508 23.4565 38.2508C14.9909 38.2508 8.15106 31.4115 8.15106 22.9461C8.15106 14.4805 14.9909 7.64067 23.4565 7.64067Z",
    fill: "#7ABF5B"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/searchIcon.bc8a9421e8aec37b48c261e48d3331e7.svg";
export { ForwardRef as ReactComponent };